"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cryptocurrencies = exports.isCryptoCurrency = void 0;
const cryptocurrencies_1 = require("../types/cryptocurrencies");
function isCryptoCurrency(currency) {
    return cryptocurrencies_1.CRYPTO_CURRENCY_CODES.includes(currency);
}
exports.isCryptoCurrency = isCryptoCurrency;
exports.Cryptocurrencies = {
    BTC: { type: "crypto", name: "Bitcoin", symbol: "฿", decimal: ".", position: "pre" },
    ETH: { type: "crypto", name: "Ethereum", symbol: "Ξ", decimal: ".", position: "pre" },
    LTC: { type: "crypto", name: "Litecoin", symbol: "Ł", decimal: ".", position: "pre" },
};
